import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import de from 'vuetify/es5/locale/de'
import '@fortawesome/fontawesome-pro/css/all.css'

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#0A0A14', // anthracite
				black: '#0A0A14', // anthracite
				anthracite: '#0A0A14',
				beige: '#F5F5F0',
				accent: '#ff0000', // red
				red: '#C62929',
				success: '#82B73E', // green
				green: '#82B73E',
				white: '#FFFFFF'
			}
		},
	},
	thresholds: {
		lg: 1253,
	},
	lang: {
		locales: {de},
		current: 'de',
	},
	icons: {
		iconfont: 'fa'
	},
})
